import { gsap } from 'gsap'

import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { ScrollSmoother } from 'gsap/ScrollSmoother'

gsap.registerPlugin(ScrollSmoother)
/**
 * ScrollSmootherManager
 *
 * Manages GSAP ScrollSmoother instances with proper lifecycle handling.
 * Automatically detects touch devices and provides methods for creating,
 * refreshing, resetting, and recreating ScrollSmoother instances.
 * Useful for SPA applications where ScrollSmoother needs to be managed
 * across page transitions.
 */
export class ScrollSmootherManager {
	constructor(config = {}) {
		this.config = {
			smooth: 0.5,
			effects: false,
			...config,
		}
		this.instance = null
	}

	init() {
		if (ScrollTrigger.isTouch !== 1) {
			this.create()
		}
	}

	create() {
		this.instance = ScrollSmoother.create(this.config)
		return this.instance
	}

	refresh() {
		if (this.instance) {
			this.instance.refresh()
		}
	}

	reset() {
		if (this.instance) {
			this.instance.scrollTo(0)
			this.instance.kill()
			this.instance = null
		}
	}

	recreate() {
		this.reset()
		if (ScrollTrigger.isTouch !== 1) {
			this.create()
		}
	}

	get() {
		return this.instance || ScrollSmoother.get()
	}
}
